<template>
  <div class="wxDriverContact wv100 hv100">
    <!-- 标签 -->
    <div class="labelDiv">
      <div class="labelDivSe">
        <van-search
          v-model="keyWord"
          @search="keyWSearch"
          @cancel="keyWCancel"
          @input="keyWInput"
          placeholder="请输入搜索关键词"
        />
      </div>
    </div>
    <van-divider />
    <!-- 全选 -->
    <div v-if="multiSelect == 1 ? true : false" class="h44 bg-ff selectAllDiv">
      <van-checkbox v-model="seleclAll" @click="seleclAllChange"
        >全部选择</van-checkbox
      >
    </div>
    <van-divider />
    <van-checkbox-group class="" v-model="selectResult">
      <van-cell-group
        class="listBarB"
        :style="'padding-bottom:' + (multiSelect == 1 ? '70px;' : '15px;')"
      >
        <listScroll
          :listData="userList"
          :loadEnd="loadEnd"
          :loadEndText="loadEndText"
          @loadNext="getwxExuser"
          ref="listScrollCP"
        >
          <template v-slot:itemRow="itemData">
            <van-cell @click="toggle('checkboxes' + itemData.item.id)">
              <!-- <van-cell> -->
              <template #title>
                <div class="exUserItem">
                  <div class="exUserItemAc">
                    <van-checkbox
                      :name="itemData.item.id"
                      :ref="'checkboxes' + itemData.item.id"
                      @change="itemChange"
                    >
                    </van-checkbox>
                  </div>
                  <div class="exUserItemIm"></div>
                  <div class="exUserItemTx">
                    <p class="name driveName">
                      司机名称：{{ itemData.item.name }}
                    </p>
                    <p class="name">司机身份证：{{ itemData.item.id_card }}</p>
                  </div>
                  <div>
                    <van-icon name="arrow" color="#969799" />
                  </div>
                </div>
              </template>
            </van-cell>
            <van-divider />
          </template>
        </listScroll>
      </van-cell-group>
    </van-checkbox-group>
    <!-- 结果 -->
    <div class="resultDiv">
      <van-divider />
      <div class="resultDivImAc">
        <!-- 
          <div class="resultDivIm">
          <template v-for="(item, index) in selectUser">
            <div class="resultDivItemDiv" :key="index">
              <van-image
                @click="delSelectUser(item)"
                width="28"
                height="28px"
                fit="cover"
                :src="
                  item.avatar && item.avatar.length > 0
                    ? item.avatar
                    : 'img/face.png'
                "
              />
              <span>{{ item.name }}</span>
            </div>
          </template>
        </div> 
        -->
        <div class="resultDivAc">
          <van-button
            type="primary"
            block
            class="btnStyle1"
            @click="wxExcomfireComBack"
          >
            <template>返回</template>
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import listScroll from "../listScroll";
export default {
  props: {
    initUser: Array,
    getDataUrl: String,
    getInitDataUrl: String,
    labelUrl: String,
    getDetailUrl: String,
    upDateUserUrl: {
      type: String,
      default: ""
    },
    multiSelect: {
      type: Number,
      default: 0
    },
    type: String
  },
  data() {
    return {
      indexList: [],
      userList: [],
      selectUser: [],
      lableValue: "",
      // lableList: [{ text: "全部标签", value: "" }],
      lableList: [],
      seleclAll: false,
      sticky: false,
      keyWord: "",
      selectResult: [],
      loadEnd: false,
      page: 1,
      page_size: 20,
      loading: false,
      loadEndText: "",
      lableListResult: [],
      lableListResultTitle: "全部标签",
      selectAllTag: false,
      isLableListResultChange: false,
      lastParameter: {
        closeUnSet: false,
        lableListResult: [],
        lableListResultTitle: ""
      },
      lableGroup: {}
    };
  },
  watch: {
    selectResult() {
      this.setSelectUser();
    },
    selectAllTag(n) {
      if (n) {
        this.lableListResult = [];
        this.lableList.forEach(item => {
          this.lableListResult.push(item.value);
        });
      } else {
        if (!this.isLableListResultChange) {
          this.lableListResult = [];
        }
      }
    },
    lableListResult(n) {
      if (n.length == this.lableList.length) {
        this.selectAllTag = true;
      } else {
        this.selectAllTag = false;
      }
    }
  },
  components: {
    listScroll
  },
  async mounted() {},
  methods: {
    toggleTag(index) {
      this.isLableListResultChange = true;
      this.$refs.checkboxesTag[index].toggle();
    },
    keyWCancel() {
      console.log("keyWCancel");
      this.keyWord = "";
      this.page = 1;
      this.getwxExuser();
    },
    keyWSearch(key) {
      console.log("keyWSearch");
      this.keyWord = key;
      this.page = 1;
      this.getwxExuser();
    },
    keyWInput(key) {
      if (key.trim().length === 0) {
        console.log("keyWInput");
        this.keyWord = "";
        this.page = 1;
        this.getwxExuser();
      }
    },
    lableChange() {
      this.page = 1;
      this.getwxExuser();
    },
    // 获取外部联系人
    async getwxExuser() {
      if (this.loading === true) {
        return;
      }
      this.loading = true;
      let resData = await this.$common.http({
        url: this.getDataUrl,
        data: {
          page: this.page,
          page_size: this.page_size,
          id: this.lableGroup.id,
          keyword: this.keyWord
        }
      });
      let userList = resData.data.data;
      if (this.page === 1) {
        this.userList = [];
      }
      userList.forEach(i => {
        if (i.id == undefined) {
          i.id = i.id_card;
        }
        this.userList.push(i);
      });
      this.page += 1;
      this.loadEnd = false;
      this.loading = false;
      if (resData.data.data.length < this.page_size) {
        this.loadEnd = true;
        this.loadEndText =
          "共" + this.userList.length + "条数据，没有更多内容啦~";
      }
    },
    async setSelectUser() {
      let selectItem = {};
      this.userList.forEach(i => {
        if (i.id == this.selectResult[0]) {
          selectItem = i;
        }
      });

      let detail = await this.$common.http({
        url: this.getDetailUrl,
        data: { id_card: selectItem.id_card, id: selectItem.id }
      });

      this.$emit("wxExcomfireSelect", detail.data.data);

      console.log(selectItem);
    },
    // 获取标签数据接口
    getLebalData() {
      return this.$common.http({
        url: this.labelUrl,
        data: { type: this.type },
        noLoading: true
      });
    },
    // 确认选择
    wxExcomfireComBack() {
      this.$emit("wxExcomfireComBack");
    },
    // 全选改变
    seleclAllChange() {
      this.selectResult = [];
      if (this.seleclAll) {
        this.userList.forEach(i => {
          this.selectResult.push(i.id);
        });
      }
    },
    // 其他值改变时，全选状态变动
    changeSelectAllType() {
      let count = 0;
      this.userList.forEach(i => {
        if (this.selectResult.indexOf(i.id.toString()) >= 0) {
          count++;
        }
      });
      if (count === this.userList.length && this.userList.length != 0) {
        this.seleclAll = true;
      } else {
        this.seleclAll = false;
      }
    },
    itemChange(type, id) {
      console.log(type, id);
    },
    toggle(index) {
      // debugger;
      // console.log(index)
      // return;
      this.$refs[index].toggle();
    },
    listScrollRe() {
      this.$refs.listScrollCP.pRefresh();
    },
    // 获取初始化数据
    getInitData() {
      this.$common
        .http({
          url: this.getInitDataUrl,
          data: {
            users: this.initUser
          }
        })
        .then(res => {
          console.log(res);
        });
    },
    toggleTagAll() {
      this.isLableListResultChange = false;
      this.$refs["toggleTagAll"].toggle();
    },
    onConfirm() {
      if (this.lableListResult.length == this.lableList.length) {
        this.lableListResultTitle = "全部标签";
      } else {
        let lableListResultTitleArr = [];
        this.lableListResult.forEach(item => {
          for (let i in this.lableList) {
            let itemO = this.lableList[i];
            if (itemO.value == item) {
              lableListResultTitleArr.push(itemO.text);
              break;
            }
          }
        });
        this.lableListResultTitle =
          lableListResultTitleArr.length > 0
            ? lableListResultTitleArr.join(",")
            : "无选中标签";
      }
      this.page = 1;
      this.getwxExuser();
      this.lastParameter.closeUnSet = true;
      this.$refs.dropdownItem.toggle();
    },
    dropdownItemOpen() {
      this.lastParameter = {
        closeUnSet: false,
        lableListResult: this.lableListResult,
        lableListResultTitle: this.lableListResultTitle
      };
    },
    dropdownItemClose() {
      if (!this.lastParameter.closeUnSet) {
        this.isLableListResultChange = true;
        this.lableListResult = this.lastParameter.lableListResult;
        this.lableListResultTitle = this.lastParameter.lableListResultTitle;
      }
    },
    upDateUser() {
      this.$common
        .http({
          url: this.upDateUserUrl,
          data: {}
        })
        .then(res => {
          if (Number(res.data.errcode) == 0) {
            this.$common.mbToastSuccess(res.data.message);
          }
        });
    },
    delSelectUser(item) {
      let delIndex = "";
      this.selectResult.forEach((element, index) => {
        if (element == item.id) {
          delIndex = index;
        }
      });
      if (delIndex != "") {
        this.selectResult.splice(delIndex, 1);
      }
    }
  },
  async created() {
    // this.selectResult = this.initUser;
    // const lableGroupRes = await this.getLebalData();
    // this.lableGroup = lableGroupRes.data.data;
    this.getwxExuser();
    // if (this.selectResult.length > 0) {
    //   this.getInitData();
    // }
  }
};
</script>
<style lang="less">
.wxDriverContact {
  position: fixed;
  left: 0;
  top: 0;
  background-color: #f4f4f4;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  .h44 {
    height: 44px;
  }
  .bg-ff {
    background-color: #ffffff;
  }
  .van-divider {
    margin: 0;
  }
  .labelDiv {
    display: flex;
    background-color: #ffffff;
    .labelDivSe {
      width: 100%;
    }
    .labelDivDe {
      width: 95px;
      box-sizing: border-box;
      .van-ellipsis {
        width: 60px;
        font-size: 14px;
      }
    }
  }
  .selectAllDiv {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
    .upDateUser {
      padding-right: 16px;
      color: #1989fa;
    }
  }
  .van-dropdown-menu__bar {
    height: 54px;
    box-shadow: none;
  }
  .van-dropdown-menu__item {
    justify-content: center;
  }
  .van-dropdown-menu__title {
    padding-left: 0;
  }
  .van-index-anchor {
    text-align: left;
    background: #f4f4f4;
  }
  .listBarB {
    height: calc(100vh - 100px);
    overflow: hidden;
    box-sizing: border-box;
  }
  .listBar {
    height: calc(100vh - 120px);
    overflow: auto;
    padding-bottom: 70px;
    box-sizing: border-box;
    background: #f4f4f4;
  }
  .exUserItem {
    display: flex;
    align-items: center;
    line-height: normal;
    height: 43px;
    .exUserItemAc {
      display: none;
    }
    .exUserItemIm {
    }
    .exUserItemTx {
      width: calc(100vw - 40px);
      p {
        margin: 0;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .driveName {
        padding-bottom: 8px;
      }
      .name {
        text-align: left;
        line-height: 14px;
      }
      .label {
        .van-tag {
          margin-right: 2px;
        }
      }
    }
  }
  .resultDiv {
    position: fixed;
    width: 100vw;
    bottom: -1px;
    left: 0;
    height: 64px;
    background-color: #ffffff;
    box-sizing: border-box;
    .resultDivImAc {
      display: flex;
      align-items: center;
      padding: 10px 16px 0px 16px;
    }
    .resultDivIm {
      width: calc(100vw - 120px);
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      text-align: left;
      height: 44px;
      display: flex;
      padding-left: 10px;
      .resultDivItemDiv {
        width: 54px;
        height: 44px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 10px;
        span {
          font-size: 12px;
        }
      }
      .van-image {
        margin-right: 3px;
        display: inline-block;
      }
    }
    .resultDivAc {
      width: 100%;
      .van-button--small {
        font-size: 14px !important;
        width: 100%;
        background-color: #008b5e;
        color: #ffffff;
      }
    }
  }
  .emptyData {
    color: #a4a4a4;
  }
  .van-index-bar__index--active {
    color: #1989fa;
  }
  .wxTx {
    font-size: 12px;
    color: #07c160;
    padding-left: 2px;
  }
  .qyWxTx {
    font-size: 12px;
    color: #ee0a24;
    padding-left: 2px;
  }
  .indexAnchor {
    line-height: 20px;
    font-size: 14px;
    padding-left: 16px;
    display: inline-block;
    width: 100%;
    text-align: left;
    background: #f4f4f4;
  }
  .van-cell__title {
    text-align: left;
  }
  .van-dropdown-menu__title--active {
    color: #1989fa !important;
  }
}
</style>
